export default function projectsPagination() {
  const elementsPerPage = 8;
  let visibleElements = elementsPerPage;

  const projectList = document.querySelector(".progetti-list");
  const elements = projectList?.querySelectorAll(".progetto");
  const showMoreBtn = projectList?.querySelector(".show-more__btn");

  if (!showMoreBtn) return;
  if (elements.length <= elementsPerPage) { 
    showMoreBtn.classList.add("show-more__btn--hide"); 
    return
  };

  elements.forEach((item, index) => {
    if (index >= visibleElements) {
      item.classList.add("progetto--hide");
    }
  });

  showMoreBtn.addEventListener("click", () => {
    visibleElements += elementsPerPage;

    elements.forEach((item, index) => {
      if (index < visibleElements) {
        item.classList.remove("progetto--hide");
      }
    });

    if (visibleElements >= elements.length) {
      showMoreBtn.classList.add("show-more__btn--hide");
    }
  });
}